import api from './api';

export const salesOrderService = {
  async getFormData(pointOfSaleId = null) {
    const response = await api.get('/ventas/orders/form-data', {
      params: pointOfSaleId ? { point_of_sale_id: pointOfSaleId } : undefined,
    });
    return response.data;
  },

  async getOrders(params = {}) {
    const response = await api.get('/ventas/orders', { params });
    return response.data;
  },

  async getOrder(id) {
    const response = await api.get(`/ventas/orders/${id}`);
    return response.data;
  },

  async createOrder(data) {
    const response = await api.post('/ventas/orders', data);
    return response.data;
  },

  async updateOrder(id, data) {
    const response = await api.put(`/ventas/orders/${id}`, data);
    return response.data;
  },

  async toggleStatus(id) {
    const response = await api.delete(`/ventas/orders/${id}`);
    return response.data;
  },

  async deleteOrder(id) {
    const response = await api.delete(`/ventas/orders/${id}/permanent`);
    return response.data;
  },

  async getReferenceExitGuides(params = {}) {
    const response = await api.get('/ventas/orders/references/exit-guides', { params });
    return response.data;
  },

  async peekSeries(pointOfSaleId, documentType) {
    const response = await api.get('/ventas/orders/peek-series', {
      params: {
        point_of_sale_id: pointOfSaleId,
        document_type: documentType,
      },
    });
    return response.data;
  },

  async getBulkImportTemplate(params = {}) {
    const response = await api.get('/ventas/orders/bulk-import/template', { params });
    return response.data;
  },

  async bulkImport(data) {
    const response = await api.post('/ventas/orders/bulk-import', data);
    return response.data;
  },
};

export default salesOrderService;
